/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto } from '../models/Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto';
import type { Wealthlane_AwardService_Dtos_MyHoldings_MarketValueByVestingDateDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldings_MarketValueByVestingDateDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_LatestAndPriorStockData } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_LatestAndPriorStockData';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantBank } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantBank';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantDetailsGrpcDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantDetailsGrpcDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto';
import type { Wealthlane_Shared_Hosting_Dtos_CompanyDto_PrivateCompanyResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_CompanyDto_PrivateCompanyResponse';
import type { Wealthlane_Shared_Hosting_Dtos_FinanceDto_MarketPriceDetailDto } from '../models/Wealthlane_Shared_Hosting_Dtos_FinanceDto_MarketPriceDetailDto';
import type { Wealthlane_Shared_Hosting_Dtos_ParticioantBrokerAndTransferAgent_GetParticioantBrokerAndTransferAgentDetailsResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_ParticioantBrokerAndTransferAgent_GetParticioantBrokerAndTransferAgentDetailsResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantDetailsListGrpcDto } from '../models/Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantDetailsListGrpcDto';
import type { Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantTransactionListDto } from '../models/Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantTransactionListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinanceService {

    /**
     * @param indludeSelf 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceRelatedCompanyIds(
indludeSelf: boolean = false,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/related-company-ids',
            query: {
                'indludeSelf': indludeSelf,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_LatestAndPriorStockData OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceLiveMarketValueByCompanyId(
companyId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_LatestAndPriorStockData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/live-market-value-by-company-id/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyIds 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceLatestMarketValue(
companyIds?: Array<string>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/latest-market-value',
            query: {
                'CompanyIds': companyIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param input 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceLatestMarketValueByDate(
input?: Array<Wealthlane_AwardService_Dtos_MyHoldings_MarketValueByVestingDateDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_LatestMarketValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/latest-market-value-by-date',
            query: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId 
     * @param companyId 
     * @param workCountry 
     * @param workState 
     * @param workCity 
     * @param residentCountry 
     * @param residentState 
     * @param residentCity 
     * @param isFicaEligible 
     * @param usResidentStatus 
     * @param transactionId 
     * @param grantId 
     * @param planId 
     * @param participantId 
     * @param ytdIncome 
     * @param supplementalIncome 
     * @param transactionGainAmount 
     * @param isTaxEnabled 
     * @param exerciseType 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceTaxDetails(
tenantId?: string,
companyId?: string,
workCountry?: string,
workState?: string,
workCity?: string,
residentCountry?: string,
residentState?: string,
residentCity?: string,
isFicaEligible?: boolean,
usResidentStatus?: string,
transactionId?: string,
grantId?: string,
planId?: string,
participantId?: string,
ytdIncome?: number,
supplementalIncome?: number,
transactionGainAmount?: number,
isTaxEnabled?: boolean,
exerciseType: string = '',
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/tax-details',
            query: {
                'TenantId': tenantId,
                'CompanyId': companyId,
                'WorkCountry': workCountry,
                'WorkState': workState,
                'WorkCity': workCity,
                'ResidentCountry': residentCountry,
                'ResidentState': residentState,
                'ResidentCity': residentCity,
                'IsFicaEligible': isFicaEligible,
                'USResidentStatus': usResidentStatus,
                'TransactionId': transactionId,
                'GrantId': grantId,
                'PlanId': planId,
                'ParticipantId': participantId,
                'YtdIncome': ytdIncome,
                'SupplementalIncome': supplementalIncome,
                'TransactionGainAmount': transactionGainAmount,
                'IsTaxEnabled': isTaxEnabled,
                'exerciseType': exerciseType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantDetailsGrpcDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceParticipantDetail(
participantId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantDetailsGrpcDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/participant-detail/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantIds 
     * @returns Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantDetailsListGrpcDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceParticipantDetailList(
participantIds?: Array<string>,
): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantDetailsListGrpcDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/participant-detail-list',
            query: {
                'ParticipantIds': participantIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantids 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantBank OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceParticipantBankDetail(
participantids?: Array<string>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantBank>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/participant-bank-detail',
            query: {
                'Participantids': participantids,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantids 
     * @returns Wealthlane_Shared_Hosting_Dtos_ParticioantBrokerAndTransferAgent_GetParticioantBrokerAndTransferAgentDetailsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceParticipantBrokerAndTA(
participantids?: Array<string>,
): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_ParticioantBrokerAndTransferAgent_GetParticioantBrokerAndTransferAgentDetailsResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/participant-broker-and-tA',
            query: {
                'Participantids': participantids,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param input 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceTaxDetailList(
input?: Array<Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantTransactionListDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/tax-detail-list',
            query: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param tenantId 
     * @param date 
     * @returns Wealthlane_Shared_Hosting_Dtos_FinanceDto_MarketPriceDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceMarketValueByDate(
companyId?: string,
tenantId?: string,
date?: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_FinanceDto_MarketPriceDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/market-value-by-date',
            query: {
                'CompanyId': companyId,
                'TenantId': tenantId,
                'Date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId 
     * @param startDate 
     * @param endDate 
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceStockPriceByDate(
tenantId?: string,
startDate?: string,
endDate?: string,
companyId?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/stock-price-by-date',
            query: {
                'TenantId': tenantId,
                'StartDate': startDate,
                'EndDate': endDate,
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId 
     * @param startDate 
     * @param endDate 
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceStockPriceByDateRange(
tenantId?: string,
startDate?: string,
endDate?: string,
companyId?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Finance_StockPriceResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/stock-price-by-date-range',
            query: {
                'TenantId': tenantId,
                'StartDate': startDate,
                'EndDate': endDate,
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_CompanyDto_PrivateCompanyResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFinanceCheckPrivateCompany(
requestBody?: Array<string>,
): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_CompanyDto_PrivateCompanyResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/finance/check-private-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceCurrentBrokerId(
companyId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/current-broker-id/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param input 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFinanceTaxDetailListForRelease(
input?: Array<Wealthlane_Shared_Hosting_Dtos_ParticipantDetailsGrpc_ParticipantTransactionListDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationResponseListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/finance/tax-detail-list-for-release',
            query: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
